import React from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_VERSION, PORTAL_LOGO_LONG, PORTAL_LOGO_MINI } from "../../Util/constant";
import SidebarProfile from "./SidebarProfile";
import { compactNumberWithTooltip } from "../user-pages/ui-helper";
import { useProfileContext } from "../context/ProfileContext";
const Sidebar = () => {
	const location = useLocation();
	const { profileData, } = useProfileContext();

	const isPathActive = (path) => {
		return location.pathname.startsWith(path);
	};

	const onRouteChanged = () => {
		document.querySelector("#sidebar").classList.remove("active");
	};

	React.useEffect(() => {
		onRouteChanged();

		// Add hover effect for sidebar icon-only mode
		const body = document.querySelector("body");
		const navItems = document.querySelectorAll(".sidebar .nav-item");

		navItems.forEach((el) => {
			el.addEventListener("mouseover", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.add("hover-open");
				}
			});
			el.addEventListener("mouseout", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.remove("hover-open");
				}
			});
		});

		return () => {
			navItems.forEach((el) => {
				el.removeEventListener("mouseover", () => { });
				el.removeEventListener("mouseout", () => { });
			});
		};
	}, [location.pathname]);

	return (
		<>
			<nav className="sidebar sidebar-offcanvas fixed-sidebar d-flex flex-column justify-content-between" id="sidebar"
				style={{ display: "flex", flexDirection: "column", overflowY: "auto", justifyContent: "space-between", }}>
				<div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
					<a className="sidebar-brand brand-logo" >
						<img src={PORTAL_LOGO_LONG} alt="logo" />
					</a>
					<a className="sidebar-brand brand-logo-mini" >
						<img src={PORTAL_LOGO_MINI} alt="logo" />
					</a>
				</div>
				<ul className="nav">
					<li className="nav-item nav-category">
						<span className=" pb-0 text-muted">
							User
							<span className="ms-2 py-0 text-muted">
								[ {APP_VERSION} ]
							</span>
						</span>
					</li>
					<li className={isPathActive("/dashboard") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/dashboard">
							<span className="menu-icon">
								<i className="mdi mdi-view-dashboard "></i>
							</span>
							<span className="menu-title">
								Dashboard
							</span>
						</Link>
					</li>

					<li className="nav-item nav-category ">
						<span className=" pb-0 text-muted">Account Management</span>
					</li>
					<li className={isPathActive("/accounts") ? "nav-item menu-items active" : "nav-item menu-items"} >
						<Link className="nav-link" to="/accounts">
							<span className="menu-icon">
								<i className="mdi mdi-account-group "></i>
							</span>
							<span className="menu-title">
								Accounts
							</span>
						</Link>
					</li>
					{/* Whitelabel User Management Menu Shows When User is Whitelabel */}
					{profileData?.is_whitelabel && (
						<li className={isPathActive("/user-management") ? "nav-item menu-items active" : "nav-item menu-items"} >
							<Link className="nav-link" to="/user-management">
								<span className="menu-icon">
									<i className="mdi mdi-account-cog"></i>
								</span>
								<span className="menu-title">
									User Management
								</span>
							</Link>
						</li>
					)}
					<li className={isPathActive("/copytrading") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/copytrading">
							<span className="menu-icon">
								<i className="mdi mdi-trending-up "></i>
							</span>
							<span className="menu-title">
								Copy Trading
							</span>
						</Link>
					</li>
					<li className={isPathActive("/bridge") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/bridge">
							<span className="menu-icon">
								<i className="mdi mdi-chart-line"></i>
							</span>
							<span className="menu-title">
								TradingView
							</span>
						</Link>
					</li>
					<li className={isPathActive("/orderhistory") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/orderhistory">
							<span className="menu-icon">
								<i className="mdi mdi-history "></i>
							</span>
							<span className="menu-title">
								Order History
							</span>
						</Link>
					</li>
					<li className={`nav-item menu-items ${isPathActive("/orderdetails") ? "active" : ""}`}>
						<Link className="nav-link" to="/orderdetails" >
							<span className="menu-icon">
								<i className="mdi mdi-receipt"></i>
							</span>
							<span className="menu-title">
								Order Details
							</span>
						</Link>
					</li>
					{profileData?.telegram_feature_enabled && (
						<li className={isPathActive("/telegram-bot") ? "nav-item menu-items active" : "nav-item menu-items"}>
							<Link className="nav-link" to="/telegram-bot">
								<span className="menu-icon">
									<i className="mdi mdi-telegram"></i>
								</span>
								<span className="menu-title">
									Telegram Bot
								</span>
							</Link>
						</li>
					)}

					<li className={isPathActive("/wallet") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/wallet">
							<span className="menu-icon">
								<i className="mdi mdi-wallet "></i>
							</span>
							<span className="menu-title">
								Wallet <span className="text-primary">(${compactNumberWithTooltip(profileData?.current_credit, "Current Credit")})</span>
							</span>
						</Link>
					</li>
					{/* Whitelabel Transaction Menu Shows When User is Whitelabel */}
					{profileData?.is_whitelabel && (
						<li className={isPathActive("/transaction") ? "nav-item menu-items active" : "nav-item menu-items"} >
							<Link className="nav-link" to="/transaction">
								<span className="menu-icon">
									<i className="mdi mdi-cash-multiple"></i>
								</span>
								<span className="menu-title">
									Transaction
								</span>
							</Link>
						</li>
					)}

					<li className={isPathActive("/referral") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/referral">
							<span className="menu-icon">
								<i className="mdi mdi-share-variant "></i>
							</span>
							<span className="menu-title">
								Referral
							</span>
						</Link>
					</li>
					<li className={isPathActive("/activitylogs") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/activitylogs">
							<span className="menu-icon">
								<i className="mdi mdi-calendar-clock"></i>
							</span>
							<span className="menu-title">
								Activity Logs
							</span>
						</Link>
					</li>
					<li className={isPathActive("/profile") ? "nav-item menu-items active" : "nav-item menu-items"}>
						<Link className="nav-link" to="/profile">
							<span className="menu-icon">
								<i className="mdi mdi-account"></i>
							</span>
							<span className="menu-title">
								Profile
							</span>
						</Link>
					</li>
					{/* Whitelabel Configurations Menu Shows When User is Whitelabel */}
					{profileData?.is_whitelabel && (
						<li className={isPathActive("/configs") ? "nav-item menu-items active" : "nav-item menu-items"}>
							<Link className="nav-link" to="/configs">
								<span className="menu-icon">
									<i className="mdi mdi-tune"></i>
								</span>
								<span className="menu-title">
									Configs
								</span>
							</Link>
						</li>
					)}

				</ul>
				<SidebarProfile />
			</nav>

		</>
	);
};

export default Sidebar;
